
import { computed, defineComponent } from 'vue'

export default defineComponent({
    props: {
        carType: {
            type: String,
            default: null
        },
        fullness: {
            type: String,
            default: '0%',
        }
    },
    setup(props) {
        const lineClasses = computed(() => {
            const percent = Number(props.fullness.split('%')[0])

            return {
                'bg-green-400': percent <= 50,
                'bg-yellow-400': percent > 50 && percent < 80,
                'bg-red-400': percent >= 80
            }
        })

        return {
            lineClasses
        }
    }
})
